import { useCallback } from 'react';
import type { AutocompleteOption } from '../../types';
import actions from '../carActions';

export const useLocationResolver = (dispatch: (action: { type: string; payload?: unknown }) => void) => {
    const resolveLocation = (setLocation: (payload?: AutocompleteOption | null) => { type: string; payload?: unknown }) =>
        useCallback(
            (payload: AutocompleteOption | null) => {
                if (payload?.placeId && !Number.parseInt(payload?.code ?? '', 10)) {
                    fetch(`https://www.finn.no/travel-api/places?id=${payload.placeId}`)
                        .then((response) => response.json())
                        .then((result) => {
                            dispatch(
                                setLocation({
                                    // @ts-ignore placeId cannot be null here as it is checked above
                                    id: payload.placeId,
                                    text: payload.text,
                                    latitude: result?.place?.latitude,
                                    longitude: result?.place?.longitude,
                                }),
                            );
                        });
                } else {
                    dispatch(setLocation(payload));
                }
            },
            [dispatch],
        );

    const resolvePickupLocation = resolveLocation(actions.setPickupLocation);
    const resolveReturnLocation = resolveLocation(actions.setReturnLocation);

    return { resolvePickupLocation, resolveReturnLocation };
};
